import * as Yup from 'yup';

import { globalMessages } from '@savgroup-front-common/core/helpers';
import { UnknownOption } from '@savgroup-front-common/types';

const ChoiceProductGenericModelSchema = Yup.object().shape({
  productGeneric: Yup.object()
    .test(
      'productGeneric',
      globalMessages.form.required,
      function test(option: UnknownOption) {
        return Boolean(option?.value);
      },
    )
    .required(globalMessages.form.required),
  productBrand: Yup.object()
    .test(
      'productBrand',
      globalMessages.form.required,
      function test(option: UnknownOption) {
        return Boolean(option?.value);
      },
    )
    .required(globalMessages.form.required),
});

export default ChoiceProductGenericModelSchema;
